import { AUTH_DISCONNECTED, ADDED_NOTIFICATION, REMOVED_NOTIFICATION } from '../mutation-types';
import { SHOW_SUCCESS_NOTIFICATION, SHOW_ERROR_NOTIFICATION, SHOW_INFO_NOTIFICATION, HIDE_NOTIFICATION } from '../actions';
import each from 'lodash/each';
import without from 'lodash/without';
import uniqueId from 'lodash/uniqueId';

import { NOTIFICATION_INFO_TIMEOUT } from '../../config';

const DEFAULT_STATE = {
   notifications: [
      // { type: 'success', body: 'System Administrator shared cart "Shared" with you.', id: uniqueId() },
      // { type: 'info', body: 'System Administrator shared cart "Shared" with you.', id: uniqueId() },
      // { type: 'error', body: 'System Administrator shared cart "Shared cart" with you.', id: uniqueId() },
   ]
};

const getters = {
   getActiveNotifications: state => state.notifications
};

const actions = {
   [SHOW_ERROR_NOTIFICATION]({ commit }, message) {
      const notification = { type: 'error', title: 'error', body: message, id: uniqueId() };
      commit(ADDED_NOTIFICATION, notification);
      setTimeout(() => commit(REMOVED_NOTIFICATION, notification), NOTIFICATION_INFO_TIMEOUT);
   },

   [SHOW_SUCCESS_NOTIFICATION]({ commit }, message) {
      const notification = { type: 'success', body: message, id: uniqueId() };
      commit(ADDED_NOTIFICATION, notification);
      setTimeout(() => commit(REMOVED_NOTIFICATION, notification), NOTIFICATION_INFO_TIMEOUT);
   },

   [SHOW_INFO_NOTIFICATION]({ commit }, message) {
      const notification = { type: 'info', body: message, id: uniqueId() };
      commit(ADDED_NOTIFICATION, notification);
      setTimeout(() => commit(REMOVED_NOTIFICATION, notification), NOTIFICATION_INFO_TIMEOUT);
   },

   [HIDE_NOTIFICATION]({commit}, notification) {
      commit(REMOVED_NOTIFICATION, notification);
   }
};

const mutations = {
   [ADDED_NOTIFICATION](state, notification) {
      state.notifications = [...state.notifications, notification];
   },

   [REMOVED_NOTIFICATION](state, notification) {
      state.notifications = without(state.notifications, notification);
   },

   [AUTH_DISCONNECTED](state) {
      each(DEFAULT_STATE, ( val, key ) => {
         state[key] = val;
      });
   }
};

export default {
   state: { ...DEFAULT_STATE },
   getters,
   actions,
   mutations
};
